module.exports = __webpack_public_path__ + "static/img/fake-chart-map.3ded13e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fake-chart-map.png
// module id = x7M7
// module chunks = 1